import React, { useEffect, useState } from "react";
import CommonTitle from "../../components/CommonTitle";
import block from "../../assets/icons/block.webp";
import BlockCard from "../../components/BlockCard";
import DateAndTimeBar from "../../components/DateAndTimeBar";
import LoadingPage from "../../components/LoadingPage";
import { getSeasonByDate } from "../../services/seasons";
import { useNavigate } from "react-router-dom";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";

const BlockRegister = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentSeason, setCurrentSeason] = useState({});
  //const [currentDate, setCurrentDate] = useState(new Date());
  //================Fetch current season by current date=====================
  useEffect(() => {
    const fetchData = async () => {
      try {
        let strDate = new Date(Date.now()).toLocaleDateString("en-US", {
          timeZone: "America/Lima",
        }); //FECHA PERU EN FORMATO MES/DIA/AñO (formato necesario para compararlo con fechas de mongo)
        let currentDate = new Date(strDate);
        currentDate.setHours(currentDate.getHours() + 5);
        let tis = currentDate.toISOString();
        const response = await getSeasonByDate(tis);
        IS_LOCAL_ENV && console.log("data del back: ", response);
        if (response.docs.length === 0) {
          Notification({
            title: "Error",
            text: `Aun no hay temporadas registradas`,
            type: "Error",
          });
          navigate("/home");
        } else {
          if (response.docs[0].status != "published") {
            Notification({
              title: "Error",
              text: `La temporada actual no está publicada`,
              type: "Error",
            });
            navigate("/home");
          } else {
            setCurrentSeason(response.docs[0]);
            setLoading(false);
          }
        }
      } catch (err) {
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="flex flex-col bg-light-green h-full ">
        {/* <ToastContainer /> */}
        <CommonTitle
          img={block}
          title={"Registro de Bloques"}
          text={
            "Se establece el procedimiento de programación de riego vitamínicos de las orquídeas Phalaenopsis."
          }
        >
          <div className=" flex flex-row items-center bg-light-purple rounded-full font-poppins px-6 py-4 text-dark-purple">
            <h2 className="font-poppins text-lg text-default-gray">
              {currentSeason?.name ? currentSeason?.name : "..."}
            </h2>
          </div>
        </CommonTitle>

        <DateAndTimeBar />

        {/* Cardcontainer */}
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="flex w-full justify-center bg-light-green h-fit">
            <div className="flex flex-wrap max-w-[1280px] 2xl:max-w-[1920px] w-full justify-center md:p-6 p-2 h-full">
              {currentSeason.blocks ? (
                currentSeason.blocks.map((block, i) => {
                  return <BlockCard blockInfo={block} key={i} />;
                })
              ) : (
                <span className="font-poppins">
                  No se ha programado una temporada para este periodo
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BlockRegister;
